export default "__VITE_ASSET__686d84b9__"